import { useMutation } from "@apollo/react-hooks";
import { Button, Form, Input, message, Typography } from "antd";
import React from "react";
import { useHistory } from "react-router-dom";
import LoginImage from "../../../Assets/Images/login.jpg";
import { CustIcon } from "../../../Components/Svgs";
import {
  LOGIN_USER,
  UPDATE_USER_LAST_SCREEN,
} from "../../../Graphql/mutations";
const { Title } = Typography;

export const LoginPage = () => {
  const history = useHistory();
  const [form] = Form.useForm();

  const [loginUser, { loading: isLoggingIn, errors: loginError }] = useMutation(
    LOGIN_USER,
    {
      context: {
        headers: {
          nologin: 1,
        },
      },
    }
  );

  const [UPDATE_USER_LAST_SCREEN_MUTATION] = useMutation(
    UPDATE_USER_LAST_SCREEN
  );

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };

  const tailLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  const onLogin = async (user) => {
    try {
      const payload = {
        variables: {
          email: user.email.toLowerCase(),
          password: user.password,
        },
      };

      const isLoginSuccess = await loginUser(payload);
      if (!isLoginSuccess.errors) {
        const {
          data: {
            login: {
              access_token,
              id,
              loggedInUser: {
                last_screen,
                userRole,
                is_password_reset,
                is_phone_verified,
                is_super_admin,
              },
            },
          },
        } = isLoginSuccess;
        if (is_super_admin) {
          message.error("Super admin cannot login to this portal.");
          return false;
        }
        localStorage.clear();
        localStorage.setItem("sanattest_access_token", access_token);
        localStorage.setItem("user_id", id);

        if (is_password_reset) {
          UPDATE_USER_LAST_SCREEN_MUTATION({
            variables: {
              user_id: localStorage.getItem("user_id"),
              last_screen: "/reset-password",
            },
          });
          history.push("/reset-password");
        } else if (history.location.search?.from) {
          history.push(history.location.search?.from);
        } else if (!last_screen) {
          if (
            userRole.length === 0 ||
            userRole[0]?.jobRolesData?.access_type === "owner"
          ) {
            if (!is_phone_verified) {
              history.push("/otp-verification", {
                nextPage: "/on-boarding/business-details",
              });
            } else {
              history.push("/on-boarding/business-details");
            }
          } else {
            history.push("/reset-password");
          }
        } else {
          history.push(last_screen);
        }
      } else {
        isLoginSuccess.errors.forEach((e) => {
          return message.error(e.message);
        });
      }
    } catch (err) {}
  };

  return (
    <div className="rowSec">
      <div className="colSec onBoardingLeft">
        <img src={LoginImage} alt="" className="" />
      </div>
      <div className="colSec onBoardingRight">
        <div className="login">
          <Title level={2}>
            <CustIcon type="left-arrow" onClick={() => history.push('/welcome')} />{" "}
            Login
          </Title>
          <p className="mb-4 subTitle">
            Enter your email and password below to continue.
          </p>
          <Form form={form} {...layout} name="basic" onFinish={onLogin}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please enter an email!",
                  whitespace: true,
                },
                {
                  type: "email",
                  message: "Enter Valid Email Address",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please enter an password!",
                  whitespace: true,
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item {...tailLayout} className="buttonSec pt-2">
              <div className="d-flex align-items-center justify-content-between">
                <Button
                  loading={isLoggingIn}
                  type="primary"
                  shape="round"
                  size="large"
                  htmlType="submit"
                >
                  Submit
                </Button>
                <label
                  className="pl-4 font-weight-normal noselect cursorPointer"
                  onClick={() => history.push("/forgot-password")}
                >
                  Forgot your password?
                </label>
              </div>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};
